import type { CartNotification } from '@libs/common-types';
import { CART_NOTIFICATIONS_STORAGE_KEY } from '@libs/core/constants';

import { useLocalStorage } from './index';

const useCartNotifications = () => {
    const [notifications, setNotifications] = useLocalStorage<CartNotification[]>(CART_NOTIFICATIONS_STORAGE_KEY);

    return { notifications, setNotifications };
};

export { useCartNotifications };
